import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=8b38e7aa&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"
import style0 from "./Initial.vue?vue&type=style&index=0&id=8b38e7aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b38e7aa",
  null
  
)

export default component.exports